const fixedScreenPanel = 1000;

const muiModal = 1300;

export const zIndex = {
  transcriptTooltip: muiModal - 10,
  fixedScreenPanel,
};
